enum PopoverDirectionEnum {
	top = 'top',
	leading = 'leading',
	trailing = 'trailing',
	bottom = 'bottom'
}

export default PopoverDirectionEnum;
